import { G_nonLimitedMethods } from "../../../../utils/globals/globals";

/**
 * Set trigger refs
 * @param {TriggerProps} trigger
 */
const setTriggerRefs = (trigger) => {
  const timeline = /** @type {TimelineMapProps} */ (trigger.get("timeline"));
  const data = /** @type {TimelineDataProps} */ (timeline.get("data"));
  const steps = /** @type {StepsMapProps} */ (timeline.get("steps"));
  const number = /** @type {Number} */ (data.get("current-step-number"));
  const currentStep = /** @type {StepProps} */ (data.get("current-step"));
  const count = /** @type {Number} */ (data.get("step-count"));
  const method = /** @type {DefaultMethodProps} */ (trigger.get("p_method"));
  const nonLimited = G_nonLimitedMethods.has(
    method?.get("name") || method?.get("value")
  );

  trigger.set("t_steps", steps);
  trigger.set("t_current-step-number", number);
  trigger.set("t_current-step", currentStep);
  trigger.set("t_step-count", count);
  trigger.set("t_data", data);

  trigger.set("is-non-limited", nonLimited);
  trigger.set("is-active", false);
  trigger.set("enter-is-active", false);
  trigger.set("leave-is-active", false);
}

export default setTriggerRefs;